import { LuClock } from "react-icons/lu";
import { getVoidAdminStage } from "../../../../data/flight/order/getVoidAdminGuidance";

function VoidConfirmationRequestProgress({ data }) {
  const steps = [
    "Request received",
    "Review",
    "Send to airline",
    "Airline processing",
    "Wallet settlement",
    "Completed",
  ];

  const stage = getVoidAdminStage(data);
  const activeByStage = {
    needs_manual_review: 2,
    auto_processing: 3,
    needs_manual_void: 3,
    send_failed: 3,
    awaiting_supplier: 4,
    settlement_pending: 5,
    settlement_failed: 5,
    completed: 7,
    declined: 2,
    supplier_failed: 4,
    failure_settled: 6,
    validation_failed: 1,
    unknown: 1,
  };
  const activeStep = activeByStage[stage] || 1;

  return (
    <div className="w-full bg-white px-6 py-4 border border-gray-200 rounded-xl shadow-sm hidden lg:flex flex-col justify-between items-center mt-4 gap-3">
      <div className="w-full flex justify-between  items-center">
        {steps.map((label, index) => {
          const stepNum = index + 1;
          const isActive = stepNum === activeStep;
          const isCompleted = stepNum < activeStep;

          return (
            <div
              key={label}
              className="flex-1 flex flex-col items-center relative"
            >
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center z-10 ${
                  isCompleted
                    ? "bg-primary1 text-white"
                    : isActive
                      ? "bg-yellow-400 text-white"
                      : "bg-gray-200 text-gray-500"
                }`}
              >
                {isCompleted ? (
                  <span className="text-lg font-semibold">✓</span>
                ) : isActive ? (
                  <LuClock className="text-lg text-white" />
                ) : (
                  <span className="text-base font-semibold">{stepNum}</span>
                )}
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`absolute left-1/2 top-5 h-[2px] w-full -translate-y-1/2 ${
                    isCompleted ? "bg-primary1" : "bg-gray-200"
                  }`}
                ></div>
              )}

              <div
                className={
                  "whitespace-nowrap text-xs mt-1 " +
                  (isActive ? "text-black" : "text-gray-400")
                }
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VoidConfirmationRequestProgress;
